import React, { useState, useEffect } from "react";
import { pdfjs } from "react-pdf";
import { Document, Page } from "react-pdf";
import axios from "../../helper/axios";
import { useParams } from "react-router-dom";

import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

import "./RDBResume.scss";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function RDBResume({ resumeResult }) {
  const [numPages, setNumPages] = useState(null);
  const resumeId = useParams().resumeID;
  const [scale, setScale] = useState(1.1); // Default zoom level

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <>
      <div className="resume-preview-title">
        <h4 className="resume-preview-text">Resume</h4>
      </div>
      <div
        className="resume-preview-wrapper"
        style={{
          height: "90vh",
          overflowY: "auto",
          border: "1px solid #ccc",
          padding: "10px",
        }}
      >
        <Document
          file={`data:application/pdf;base64,${resumeResult.resume}`}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              scale={scale}
            />
          ))}
        </Document>
      </div>
    </>
  );
}

export default RDBResume;
